<template>
<v-container fluid class="login-page pa-0">
  <!-- DIALOG MEMBRESÍA -->
  <v-dialog v-model="dialogmembresia" max-width="760px">
    <v-card class="modal-card">
      <v-card-title class="modal-title">
        <v-icon color="primary" left>mdi-card-account-details-outline</v-icon>
        Número de membresía
      </v-card-title>

      <v-card-text class="modal-text">
        En tu tarjeta digital o contrato puedes encontrar el número de membresía.
      </v-card-text>

      <v-img :src="imageSrc1" contain max-height="420" />

      <v-card-actions class="justify-end">
        <v-btn color="primary" rounded depressed @click="dialogmembresia = false">
          Entendido
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- DIALOG PASSWORD -->
  <v-dialog v-model="dialogpass" max-width="760px">
    <v-card class="modal-card">
      <v-card-title class="modal-title">
        <v-icon color="primary" left>mdi-lock-question</v-icon>
        ¿Cuál es mi contraseña?
      </v-card-title>

      <v-card-text class="modal-text">
        Tu contraseña corresponde a la combinación indicada en tu documentación.
      </v-card-text>

      <v-img :src="imageSrc2" contain max-height="420" />

      <v-card-actions class="justify-end">
        <v-btn color="primary" rounded depressed @click="dialogpass = false">
          Entendido
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-row class="login-wrapper">
    <!-- PANEL IZQUIERDO -->
    <v-col cols="12" md="7" class="login-brand d-none d-md-flex">
      <div class="brand-overlay"></div>

      <div class="brand-content">
        <div class="brand-chip">
          <v-icon small color="white" class="mr-1">mdi-shield-check-outline</v-icon>
          Membresía médica
        </div>

        <h1>Bienvenido a MediCover</h1>

        <p>
          Accede de forma segura a tu membresía, beneficios, recibos y servicios médicos disponibles.
        </p>

        <div class="brand-features">
          <div class="feature-item">
            <v-icon color="white" small>mdi-check-circle-outline</v-icon>
            Pases médicos
          </div>
          <div class="feature-item">
            <v-icon color="white" small>mdi-check-circle-outline</v-icon>
            Acceso seguro
          </div>
          <div class="feature-item">
            <v-icon color="white" small>mdi-check-circle-outline</v-icon>
            Servicios digitales
          </div>
        </div>
      </div>
    </v-col>

    <!-- PANEL LOGIN -->
    <v-col cols="12" md="5" class="login-form-section">
      <v-card class="login-card" elevation="14">
        <div class="text-center mb-6">
          <h2 class="login-title">Iniciar sesión</h2>

          <p class="login-subtitle">
            Ingresa tus credenciales para acceder a tu cuenta.
          </p>
        </div>

        <form @submit.prevent="login">
          <v-text-field
            v-model="numMem"
            :rules="membresiaRule"
            label="Número de membresía"
            outlined
            dense
            clearable
            required
            prepend-inner-icon="mdi-card-account-details-outline"
            append-outer-icon="mdi-help-circle-outline"
            hint="Se quitarán automáticamente espacios y guiones."
            persistent-hint
            maxlength="32"
            class="login-input"
            @input="validamembresia"
            @change="validamembresia"
            @click:append-outer="openModal1"
          />

          <v-text-field
            v-model="password"
            :rules="contrarquerido"
            label="Contraseña"
            outlined
            dense
            clearable
            required
            prepend-inner-icon="mdi-lock-outline"
            :type="showPassword ? 'text' : 'password'"
            :append-icon="showPassword ? 'mdi-eye-off' : 'mdi-eye'"
            append-outer-icon="mdi-help-circle-outline"
            maxlength="8"
            class="login-input"
            @click:append="togglePasswordVisibility"
            @click:append-outer="openModal2"
          />

          <v-alert dense text type="error" v-if="mostrarerror" class="mt-2">
            {{ errormensaje }}
          </v-alert>

          <v-btn
            color="azul_med"
            dark
            block
            large
            rounded
            depressed
            type="submit"
            class="mt-5 login-button"
          >
            <v-icon left>mdi-login</v-icon>
            Iniciar sesión
          </v-btn>

          <div class="text-center mt-4">
            <v-btn
              :href="WhatsApp"
              target="_blank"
              text
              small
              color="grey darken-1"
              class="font-weight-medium text-none"
            >
              <v-icon small left color="green">mdi-whatsapp</v-icon>
              ¿Necesitas ayuda para iniciar sesión?
            </v-btn>
          </div>
        </form>
      </v-card>
    </v-col>
  </v-row>
</v-container>
</template>
<script>
import { encryptPassword } from "@/utils/cryptoService";
// import CryptoJS from "crypto-js";
export default {
  name: 'LoginView',
  validations: {
  },
  data: () => ({
    numMem: null,
    membresiaRule: [
      (v) => !!v || "Número de Membresía es requerido",
      (v) =>
        /^[a-zA-Z0-9]{1,36}$/.test(v) ||
        "Valor inválido no debe incluir (-) ni espacios en blanco",
    ],

    isImageLoaded1: false,
    imageSrc1: "https://medicover.mx/img/ayuda/img1.png",
    isImageLoaded2: false,
    imageSrc2: "https://medicover.mx/img/ayuda/img2.png",
    dialogpass: false,
    dialogmembresia: false,
    mykey: process.env.VUE_APP_API_SECRETKEY || '',

    WhatsApp: `https://wa.me/send?phone=${process.env.VUE_APP_BASE_PHONEWHATSWEB}&text=${encodeURIComponent('Hola, necesito ayuda al iniciar sesión como usuario ')}`,
    email: '',
    mostrarerror: false,
    errormensaje: null,
    emailRules: [
      (v) => !!v || 'Correo requerido',
      (v) => /.+@.+\..+/.test(v) || 'Correo invalido'
    ],
    password: '',
    showPassword: false,
    contrarquerido: [
      (v) => !!v || "Contraseña requerida",
      (v) =>
        (v && v.length === 8) ||
        "La contraseña debe tener exactamente 8 caracteres", // Longitud exacta
    ],
  }),
  computed: {
    checkboxErrors() {
      const errors = []
      if (!this.$v.checkbox.$dirty) return errors
      // !this.$v.checkbox.checked && errors.push('You must agree to continue!');
      return errors
    },
    selectErrors() {
      const errors = []
      if (!this.$v.select.$dirty) return errors
      // !this.$v.select.required && errors.push('Item is required');
      return errors
    },
    nameErrors() {
      const errors = []
      if (!this.$v.name.$dirty) return errors
      // !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long');
      // !this.$v.name.required && errors.push('Name is required.');
      return errors
    },
    emailErrors() {
      const errors = []
      if (!this.$v.email.$dirty) return errors
      // !this.$v.email.email && errors.push('Must be valid e-mail');
      // !this.$v.email.required && errors.push('E-mail is required');
      return errors
    }
  },
  created() {
    this.$store
      .dispatch('logout', {})
  },
  methods: {
    openModal1() {
      this.isImageLoaded1 = false; // Reinicia el estado
      const img = new Image();
      img.src = this.imageSrc1;
      img.onload = () => {
        this.isImageLoaded1 = true; // Marca que la imagen ya cargó
        this.dialogmembresia = true; // Muestra el modal
      };
    },
    openModal2() {
      this.isImageLoaded2 = false; // Reinicia el estado
      const img = new Image();
      img.src = this.imageSrc2;
      img.onload = () => {
        this.isImageLoaded2 = true; // Marca que la imagen ya cargó
        this.dialogpass = true; // Muestra el modal
      };
    },
    validamembresia() {
      if (!this.numMem) {
        this.numMem = "";
        return;
      }

      // Convertir a mayúsculas, quitar espacios y filtrar caracteres no alfanuméricos
      this.numMem = this.numMem
        .toUpperCase()
        .trim()
        .split('')
        .filter(char => /^[A-Z0-9]$/.test(char))
        .join('');
    },
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    validate() {
      // this.$refs.form.validate();
    },
    /*
    encryptPassword() {
      console.log(this.mykey.length)
      if (this.mykey.length === 32) {
        // Generar un IV aleatorio
        const iv = CryptoJS.lib.WordArray.random(16);

        // Encriptar la contraseña
        const encrypted = CryptoJS.AES.encrypt(
          this.password,
          CryptoJS.enc.Utf8.parse(this.mykey),
          {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
          }
        );

        // Combinar IV y texto cifrado
        const encryptedData = iv
          .concat(encrypted.ciphertext)
          .toString(CryptoJS.enc.Base64);

        return encryptedData;
      }
    },
    */
    async login() {
        this.$store.commit('ui/SET_LOADING', {
          value: true,
          text: 'Iniciando sesión...'
        })
      this.$store
        .dispatch("iniciosesion", {
          IdTarjeta: this.numMem,
          Password: encryptPassword(this.password),
          tipo: 'cliente'
        })
        .then(() => {
          // this.$router.replace(this.$route.query.redirect || '/');
          //this.$router.replace(this.$route.query.redirect || response);
          this.$router.replace('/user/micuenta');
          this.$store.commit('ui/SET_LOADING', {
            value: false
          })
        })
        .catch((error) => {
          if (error.response.status === 400) {
            this.mostrarerror = true;
            this.errormensaje = "Ocurrió un error al procesar tu solicitud. Por favor, intenta nuevamente más tarde.";
          } else {
            this.mostrarerror = true;
            this.errormensaje =
              "Ocurrió un error al procesar tu solicitud. Por favor, intenta nuevamente más tarde.";
          }
          this.$store.commit('ui/SET_LOADING', {
            value: false
          })
        });
    },
    submit() {
      this.$v.$touch()
    },
    clear() {
      this.$v.$reset()
      this.name = ''
      this.email = ''
    }
  }
}
</script>
<style lang="scss" scoped>
.login-page {
  min-height: 100vh;
  background: #eef3f8;
}

.login-wrapper {
  min-height: 100vh;
}

.login-brand {
  position: relative;
  align-items: center;
  padding: 80px;
  color: white;
  background:
    linear-gradient(rgba(8, 34, 63, 0.65), rgba(8, 34, 63, 0.75)),
    url('https://medicover.mx/img/login-agente.png');
  background-size: cover;
  background-position: center;
  overflow: hidden;
}

.brand-content {
  position: relative;
  max-width: 560px;
  z-index: 2;
}

.brand-chip {
  display: inline-flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  backdrop-filter: blur(8px);
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 24px;
}

.brand-content h1 {
  font-size: 48px;
  font-weight: 900;
  line-height: 1.05;
  margin-bottom: 18px;
}

.brand-content p {
  font-size: 17px;
  line-height: 1.7;
  opacity: 0.92;
}

.brand-features {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 28px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  padding: 8px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
}

.login-form-section {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 36px;
  background:
    radial-gradient(circle at top right, rgba(30, 58, 138, 0.10), transparent 32%),
    #f8fafc;
}

.login-card {
  width: 100%;
  max-width: 440px;
  padding: 38px;
  border-radius: 28px !important;
  background: rgba(255, 255, 255, 0.98) !important;
  border: 1px solid rgba(226, 232, 240, 0.9);
}


.login-title {
  font-size: 27px;
  font-weight: 900;
  color: #152033;
}

.login-subtitle {
  font-size: 14px;
  color: #64748b;
  margin-top: 6px;
}

.login-input ::v-deep .v-input__slot {
  border-radius: 14px !important;
  min-height: 44px !important;
}

.login-button {
  height: 46px !important;
  text-transform: none;
  font-weight: 800;
  letter-spacing: 0.2px;
}

.modal-card {
  border-radius: 22px !important;
  overflow: hidden;
}

.modal-title {
  font-size: 18px;
  font-weight: 800;
  color: #1f2937;
}

.modal-text {
  font-size: 14px;
  color: #64748b;
}

.text-none {
  text-transform: none;
}

@media (max-width: 960px) {
  .login-form-section {
    min-height: 100vh;
    padding: 22px;
  }

  .login-card {
    padding: 28px;
    border-radius: 24px !important;
  }
}
</style>